export const ViewDateFormat = (date, is12hourZone = true) => {
    const dateandTime = new Date(date).toLocaleDateString(
        'en-GB',
        {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: is12hourZone
        }
    );

    return dateandTime
}